/**
 * The saved files a procedural texture reads its Gradient and FastNoiseLite from, so a hook can
 * load them before the texture resolves (`resolveReference` reads them once loaded).
 */
import { findSubResource, parseResourceReference } from '../SubResourceResolver';
import { referencedFilePath } from '../resolveReference';
/** The properties of each procedural texture type that name a Gradient or a FastNoiseLite. */
const SOURCE_PROPERTIES = {
    GradientTexture2D: ['gradient'],
    NoiseTexture2D: ['noise', 'color_ramp'],
    NoiseTexture3D: ['noise', 'color_ramp'],
};
/** The files the texture `ref` names reads its sources from. None for a ref that is not a SubResource. */
export function textureSourceFiles(ref, pools) {
    const parsed = parseResourceReference(ref ?? '');
    const texture = parsed?.type === 'SubResource' ? findSubResource(pools.internalResources, parsed.id) : undefined;
    if (!texture)
        return [];
    return (SOURCE_PROPERTIES[texture.type] ?? []).flatMap((property) => referencedFilePath(texture.data[property], pools) ?? []);
}
//# sourceMappingURL=textureSourceFiles.js.map